<template>
  <q-footer class="text-white bg-grey-9">
    <div class="q-py-xl q-px-md">
      <div
        :class="
          $q.screen.xs
            ? 'row q-col-gutter-sm justify-center items-center'
            : 'row q-col-gutter-xl justify-center items-center'
        "
      >
        <div class="col-xs-6 col-sm-auto col-md-auto flex justify-center">
          <img
            :src="logoUno"
            style="height: 150px; width: auto; object-fit: contain"
          />
        </div>

        <div class="col-xs-6 col-sm-auto col-md-auto flex justify-center">
          <img
            :src="logoDos"
            style="height: 150px; width: auto; object-fit: contain"
          />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-5">
          <div class="row q-col-gutter-sm justify-center">
            <div class="col-xs-12 col-sm-5">
              <q-list
                :dense="$q.screen.lt.md"
                :class="{ 'text-center': $q.screen.lt.md }"
              >
                <q-item
                  clickable
                  v-ripple
                  @click="irLink('https://www.red.cl/planifica-tu-viaje/')"
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Planifica tu viaje</q-item-section
                  >
                </q-item>
                <q-item
                  clickable
                  v-ripple
                  @click="irLink('https://www.red.cl/mapas-y-horarios/')"
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Mapas y recorridos</q-item-section
                  >
                </q-item>
                <q-item
                  clickable
                  v-ripple
                  @click="irLink('https://www.red.cl/tarifas-y-recargas/')"
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Tarifas y pagos</q-item-section
                  >
                </q-item>
                <q-item
                  clickable
                  v-ripple
                  @click="
                    irLink('https://www.red.cl/acerca-de-red/que-es-red/')
                  "
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Acerca de Red Movilidad</q-item-section
                  >
                </q-item>
              </q-list>
            </div>

            <div class="col-xs-12 col-sm-5">
              <q-list
                :dense="$q.screen.lt.md"
                :class="{ 'text-center': $q.screen.lt.md }"
              >
                <q-item
                  clickable
                  v-ripple
                  @click="irLink('https://www.red.cl/noticias/')"
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Noticias</q-item-section
                  >
                </q-item>
                <q-item clickable v-ripple @click="irPreguntasFrecuentes()">
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Preguntas Frecuentes</q-item-section
                  >
                </q-item>
                <q-item clickable v-ripple @click="irHome()">
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Reclamos y sugerencias</q-item-section
                  >
                </q-item>
                <q-item
                  clickable
                  v-ripple
                  @click="
                    irLink(
                      'https://www.red.cl/condiciones-de-uso-y-privacidad/'
                    )
                  "
                >
                  <q-item-section class="text-weight-bold text-subtitle1"
                    >Privacidad</q-item-section
                  >
                </q-item>
              </q-list>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-3 flex justify-center">
          <div :class="{ 'text-center': $q.screen.lt.md }">
            <q-list dense>
              <q-item
                clickable
                v-ripple
                @click="llamar('800 73 0073')"
                class="justify-center"
              >
                <q-item-section avatar min-width="30px">
                  <q-icon name="phone" size="sm" />
                </q-item-section>
                <q-item-section class="text-h5 text-weight-bolder"
                  >800 73 0073</q-item-section
                >
              </q-item>
              <q-item
                clickable
                v-ripple
                @click="llamar('600 730 0073')"
                class="justify-center"
              >
                <q-item-section avatar min-width="30px">
                  <q-icon name="phone_iphone" size="sm" />
                </q-item-section>
                <q-item-section class="text-h5 text-weight-bolder"
                  >600 730 0073</q-item-section
                >
              </q-item>
            </q-list>

            <div class="q-mt-md">
              <div class="text-weight-bold q-mb-sm">Síguenos en:</div>
              <div class="row justify-center q-gutter-md">
                <q-img
                  :src="logoFacebook"
                  class="cursor-pointer"
                  style="width: 40px"
                  @click="
                    irLink('https://www.facebook.com/redmovilidadoficial/')
                  "
                />
                <q-img
                  :src="logoX"
                  class="cursor-pointer"
                  style="width: 30px"
                  @click="irLink('https://x.com/RED_movilidad')"
                />
                <q-img
                  :src="logoYoutube"
                  class="cursor-pointer"
                  style="width: 40px"
                  @click="
                    irLink(
                      'https://www.youtube.com/channel/UCQ6P6Av1qvxy_CEFQYeV-sA'
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-footer>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { copyToClipboard, Notify } from "quasar";
@Component
export default class TheFooter extends Vue {
  private logoUno =
    process.env.VUE_APP_AWS_ASSETS + "/logos/logo_uno_footer.png";
  private logoDos =
    process.env.VUE_APP_AWS_ASSETS + "/logos/logo_dos_footer.png";
  private logoFacebook = process.env.VUE_APP_AWS_ASSETS + "/logos/facebook.png";
  private logoX = process.env.VUE_APP_AWS_ASSETS + "/logos/twitter.png";
  private logoYoutube = process.env.VUE_APP_AWS_ASSETS + "/logos/youtube.png";
  private copiarClipboard(texto: any) {
    copyToClipboard(texto)
      .then(() => {
        Notify.create({
          color: "positive",
          message: "Se ha copiado el Número de Teléfono.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      })
      .catch(() => {
        Notify.create({
          color: "negative",
          message: "Ha ocurrido un problema. Por favor, inténtelo de nuevo.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      });
  }

  private irLink(link: string) {
    window.open(link, "_blank");
  }

  private irPreguntasFrecuentes() {
    this.$router.push("/preguntas-frecuentes");
  }

  private irHome() {
    this.$router.push("/");
  }

  private llamar(data: any) {
    const numero = data;
    window.open("tel:" + numero);
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/colores";
.footer {
  min-height: 75px;
  background-color: $color-primario-uno;
}
.mc-logo {
  height: 11px;
  margin-right: 5px;
}
.phone-footer {
  @media (max-width: 1024px) {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}
</style>
